export default "__VITE_ASSET__aMFM6GAE__"